<script setup lang="ts">
const props = defineProps<{
  modelValue: string[]
  options: string[]
}>()

const emit = defineEmits(['update:modelValue'])

const isSelected = (option: string) => props.modelValue.includes(option)

const toggle = (option: string) => {
  const selected = [...props.modelValue]
  const index = selected.indexOf(option)
  if (index > -1) {
    selected.splice(index, 1)
  } else {
    selected.push(option)
  }
  emit('update:modelValue', selected)
}
</script>

<template>
  <div class="flex flex-wrap gap-2">
    <button
      v-for="option in options"
      :key="option"
      type="button"
      class="cursor-pointer select-none whitespace-nowrap rounded-full border-none px-[18px] py-[9px] text-[13px] font-medium shadow-sm ring-1 transition-shadow duration-150 ease-[cubic-bezier(0.22,1,0.36,1)] active:translate-y-px active:shadow-sm"
      :class="
        isSelected(option)
          ? 'bg-[#009192]/[0.08] text-[#009192] ring-[#009192] hover:shadow-md'
          : 'bg-white text-gray-700 ring-gray-700/20 hover:shadow-md hover:ring-gray-700/30'
      "
      @click="toggle(option)"
    >
      {{ option }}
    </button>
  </div>
</template>
